module.exports = __webpack_public_path__ + "media/images/Psm_5V6K-48840ccb1a8f2e0221e00b686c01c1b4.jpeg";